/*
 * Copyright (c) Dito Technologies
 */

import React from "react";
import styles from "./Pill.module.scss";
import classnames from "classnames";

interface Props {
    title: string;
    onClick: React.MouseEventHandler<HTMLDivElement>
    selected?: boolean
}

const Pill: React.FC<Props> = ({title, onClick, selected}) => {
    return (
        <div className={classnames(styles.container, {
            [styles.selected]: selected
        })} onClick={onClick}>
            {title}
        </div>
    )
}

export default Pill;